<template>
  <div>
    <slot name="activator" :open="open"></slot>
    <oie-portal-wrapper :name="name">
      <template #title>
        <h2>{{ title }}</h2>
      </template>
      <div class="pricelist-download-slide-in__content">
        <p v-if="text">
          {{ text }}
        </p>
        <oie-form-wrapper @submit="addOption">
          <fieldset class="pricelist-download-fieldset">
            <legend>
              {{ t('priceListFormat') }}
            </legend>
            <oie-base-radio-checkbox
              v-model="selectedValue"
              value="xlsx"
              name="file-type"
              label="Excel (.xlsx)"></oie-base-radio-checkbox>

            <oie-base-radio-checkbox
              v-model="selectedValue"
              value="csv"
              name="file-type"
              label=".csv"></oie-base-radio-checkbox>
          </fieldset>
          <oie-action-wrapper class="pricelist-download-actions">
            <template #left>
              <oie-base-action :disabled="!selectedValue" type="submit" size="large">
                {{ confirmText || tStatic('confirm') }}
              </oie-base-action>
            </template>
          </oie-action-wrapper>
        </oie-form-wrapper>
      </div>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedValue: ''
    }
  },
  beforeMount() {
    this.name = this.$attrs.id || _.uniqueId('add-option-')
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    open() {
      this.setActiveSlideIn(this.name)
    },
    async addOption() {
      this.$emit('add-option', this.selectedValue)
    }
  }
}
</script>

<style lang="scss">
.pricelist-download-slide-in__content {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}
.pricelist-download-fieldset {
  margin-bottom: 1.75rem;
}
.pricelist-download-fieldset legend{
  @include body-smaller-semi-bold;
  margin-bottom: measure(quarter);
}
.pricelist-download-fieldset .base-radio-checkbox {
  @include body;
}
.pricelist-download-fieldset .base-radio-checkbox:not(:last-child) {
  margin-bottom: 1rem;
}
.pricelist-download-actions {
  .base-action,
  .action-wrapper__container {
    width: 100%;
  }
}
</style>
